import { useMemo } from 'react';

import { InputGroupV2, UniversalSelect } from '@equip.health/ui';

import {
  getSelectedUniversalSelectOption,
  inquiryEnumMenuOptionsMapper,
} from '~/lib/util/inquiry.util';
import { useGetClosedReasonsQuery } from '~/store/services/inquiry';

import { DropdownBaseProps } from './types';
import { TaskCloseVoidReasons } from '~/lib/constants/enumeration.constants';

interface ClosedReasonDropdownProps extends DropdownBaseProps {
  modalId?: string;
  handleNoShowEmailCheckbox?: (value: boolean) => void;
}

const ClosedReasonDropdown = ({
  id,
  isDisabled = false,
  isInvalid = false,
  isRequired = false,
  modalId,
  onSelect,
  placeholder = '',
  handleNoShowEmailCheckbox,
  value,
}: ClosedReasonDropdownProps) => {
  const { data: closedReasons } = useGetClosedReasonsQuery();
  const closedReasonOptions = useMemo<UniversalSelectOption[]>(() => {
    return inquiryEnumMenuOptionsMapper(closedReasons);
  }, [closedReasons]);

  const handleChange = (selected: UniversalSelectOption) => {
    onSelect(selected?.value);
    const selectedReason = closedReasons?.find(
      ({ id }) => id === selected?.value,
    );
    handleNoShowEmailCheckbox?.(
      selectedReason?.name?.toLowerCase() ===
        TaskCloseVoidReasons.MIA_NO_CONTACT.toLowerCase(),
    );
  };

  return (
    <InputGroupV2
      id={`${id}__closed-reason`}
      isRequired={isRequired}
      label="Closed reason"
    >
      <UniversalSelect
        id={`${id}__closed-reason`}
        isDisabled={isDisabled}
        isInvalid={isInvalid}
        isSearchable
        isSingleSelect
        modalId={modalId}
        onChange={(selected: UniversalSelectOption) => handleChange(selected)}
        options={closedReasonOptions}
        placeholder={placeholder}
        value={getSelectedUniversalSelectOption(value, closedReasonOptions)}
      />
    </InputGroupV2>
  );
};

export default ClosedReasonDropdown;
